module.exports = __webpack_public_path__ + "static/media/red.217ac9c8.png";